import script from "./SubscriptionTierSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionTierSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionTierSwitcher.vue?vue&type=style&index=0&id=d5c4143e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c4143e"]])

export default __exports__